import React, { Fragment, useState, useEffect } from "react";
import PageTitle from "../../../layouts/PageTitle";
import axios from "axios";
import swal from "sweetalert";
import { Alert, Button, Modal, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const Checkout = () => {
  const { t } = useTranslation();
  const [withdraw, setWithdraw] = useState([]);
  const [depositInput, setDepositInput] = useState({ amount: '', with_otp: '', password: '', error_list: [] });
  const [income, setIncome] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingdd, setLoadingotp] = useState(false);
  const [user, setUser] = useState([]);
    useEffect(()=>{
      const auth_token = localStorage.getItem('auth_token');
      const selectedCurrency = localStorage.getItem('selectedCurrency');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
            currency: selectedCurrency,
        }
      if (auth_token !== null) {
         axios.post('/apps-profile',data)
         .then(response=>{
           setUser(response.data)
           console.log(response.data)
           
           })
           .catch(error=>{
             console.log(error)
         })
      }

    },[])



  let balance;
  if (user == "") {
    console.log(user);
  }else{
    balance=user.data.balance;
  }


  useEffect(() => {
    axios.post('/apps-withdraw', { key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9' })
      .then(res => setWithdraw(res.data.data))
      .catch(err => console.log(err));
  }, []);

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  }

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: depositInput.amount,
      with_otp: depositInput.with_otp,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
    };

    if (auth_token && !loading) {
      setLoading(true);
      axios.post('/apps-withdraw-sub', data)
        .then(res => {
          setLoading(false);
          if (res.data.status === 'success') {
            swal("Success", res.data.message, "success");
            setDepositInput({ amount: '', with_otp: '', password: '', error_list: [] });
          } else if (res.data.status === 'fail') {
            swal("Warning", res.data.message, "warning");
          } else {
            setDepositInput({ ...depositInput, error_list: res.data.validation_error });
          }
        })
        .catch(() => setLoading(false));
    }
  };

  const fetchIncomeData = () => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    if (auth_token) {
      axios.post('/get-method', { key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', currency: selectedCurrency })
        .then(res => setIncome(res.data.data))
        .catch(err => console.error(err));
    }
  };

  useEffect(() => {
    fetchIncomeData();
  }, []);


  const handleLinkClick = () => {
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      root_url: "https://account.segma.app/",
    };
    if (auth_token && !loadingdd) {
      setLoadingotp(true);
      axios.post('/email-withdraw-verify', data)
        .then(res => {
          setLoadingotp(false);
          if (res.data.status === 'success') {
            swal("success", res.data.message, "success");
          } else {
            swal("Warning", res.data.message, "warning");
          }
        })
        .catch(error => {
          setLoadingotp(false);
          console.log(error);
        });
    }
  };

  return (
    <Fragment>
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-body p-5">
                <h3 className="card-title mb-4 text-center  ">{t('pro_with_withdraw')}</h3>
                              
                <button
                  className="btn btn-lg w-100 text-white d-flex align-items-center justify-content-center gap-2 shadow  mb-3"
                  style={{
                    background: "#002f6a",
                    borderRadius: "14px",
                    transition: "0.3s",
                  }}
                >
                  <i className="fa fa-wallet fs-4"></i>
                  <span className="fs-3 fw-bold">Balance:  ${Number(balance).toFixed(2)}</span>
                </button>

                <form onSubmit={depositSubmit} className="needs-validation" noValidate>
                  
                  {/* Wallet Info Table */}
                  <div className="mb-4">
                  {income.map((row) => (
                    <div 
                      key={row.id} 
                      className="d-flex justify-content-between align-items-center mb-3 p-3 rounded" 
                      style={{ backgroundColor: "#f8f9fa", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
                    >
                      <div style={{ fontWeight: "600", color: "#343a40" }}>Wallet Chain:</div>
                      <button 
                        type="button" 
                        className="btn btn-outline-primary btn-sm" 
                        style={{ minWidth: "150px", fontWeight: "bold" }}
                      >
                        {row.wallet_chain}
                      </button>
                    </div>
                  ))}
                  
  {income.map((row) => (
    <div 
      key={row.id + "-address"} 
      className="d-flex justify-content-between align-items-center mb-3 p-3 rounded" 
      style={{ backgroundColor: "#f8f9fa", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
    >
      <div style={{ fontWeight: "600", color: "#343a40" }}>Wallet Address:</div>
      <button 
        type="button" 
        className="btn btn-outline-success btn-sm" 
        style={{ minWidth: "150px", fontWeight: "bold" }}
      >
        {row.wallet_address}
      </button>
    </div>
  ))}
  
  {income.map((row) => (
    <div 
      key={row.id + "-time"} 
      className="d-flex justify-content-between align-items-center mb-3 p-3 rounded" 
      style={{ backgroundColor: "#f8f9fa", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
    >
      <div style={{ fontWeight: "600", color: "#343a40" }}>Time:</div>
      <button 
        type="button" 
        className="btn btn-outline-secondary btn-sm" 
        style={{ minWidth: "150px", fontWeight: "bold" }}
      >
        {row.create_time}
      </button>
    </div>
  ))}
</div>


                  {/* Amount Field */}
                  <div className="mb-3">
                    <label htmlFor="amount" className="form-label fw-bold">{t('pro_with_amount')}</label>
                    <input
                      type="text"
                      className="form-control"
                      id="amount"
                      placeholder="Enter amount"
                      name="amount"
                      onChange={handleInput}
                      value={depositInput.amount}
                      required
                    />
                    {depositInput.error_list.amount && (
                      <small className="text-danger">{depositInput.error_list.amount}</small>
                    )}
                  </div>

              <div className="mb-3">
                <label htmlFor="with_otp" className="form-label fw-bold">
                 Send Withdrawal OTP
                </label>

                <div className="col-12">
                  <Alert variant="warning">
                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                      <input
                        type="text"
                        className="form-control"
                        id="with_otp"
                        placeholder="Enter OTP"
                        name="with_otp"
                        onChange={handleInput}
                        value={depositInput.with_otp}
                        required
                      />
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleLinkClick}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {loadingdd ? 'Sending...' : 'Send Now'}
                      </Button>
                    </div>
                  </Alert>
                </div>

                    {depositInput.error_list.with_otp && (
                      <small className="text-danger">{depositInput.error_list.with_otp}</small>
                    )}
              </div>


                  {/* Password Field */}
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label fw-bold">{t('pro_with_password')}</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="Enter password"
                      name="password"
                      onChange={handleInput}
                      value={depositInput.password}
                      required
                    />
                    {depositInput.error_list.password && (
                      <small className="text-danger">{depositInput.error_list.password}</small>
                    )}
                  </div>

                  {/* Submit Button */}
                  <div className="d-grid">
                    <button
                      className="btn btn-primary btn-lg"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : t('pro_with_withdraw')}
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
